/**
* Copyright by:

* by ESS-Ehrhardt Software Solutions & Service GmbH
* Basselscheider Str. 55
* D-56281 Emmelshausen
* +49 (0) 67 42 / 87 27 0
* info@epg.com
*/
export class WorkflowModel {
  constructor(
    public _id: string,
    public company_id: string,
    public name: string,
    public description: string | null,
    public initialState: number,
    public input: {} | undefined,
    public output: {} | undefined,
    public createdAt: string,
    public updatedAt: string,
    public version: number,
    public references?: string[],
    public states?: object[],
    public executableFromMobile?: boolean,
    public locationTracingEnabled?: boolean,
    public enableStatesTimestamps?: boolean,
    public is_deleted?: boolean,
    //designer properities
    public designerId?: string,
    public is_published?: boolean,
    public is_draft?: boolean,
    public is_valid?: boolean,
    public availableInDesigner?: boolean
  ) {}

  get combinedId(): string {
    return `${this._id ?? ''}_${this.designerId ?? ''}`;
  }
}

export class WorkflowCreationModel {
  constructor(
    public name: string,
    public description?: string,
    public initialState?: string,
    public states?: string[],
    public input?: string,
    public output?: string,
    public executableFromMobile?: boolean,
    public locationTracingEnabled?: boolean,
    public enableStatesTimestamps?: boolean,
    public currentColorIndex?: number
  ) {}
}
